<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 5: Project References
    </h2>
    <form @submit.prevent="passes(goToNextPage)">
      <p>List a sampling of projects that represent the firm's accomplishments.</p>
      <h3>Project #1</h3>
      <d-field label="Project Name">
        <d-input v-model="projectOneName" aria-label="project one name" required />
      </d-field>
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="City" class="px-5 w-full md:w-1/2">
          <d-input v-model="projectOneCity" aria-label="project one city" required />
        </d-field>
        <d-field label="State/Province" class="px-5 w-full md:w-1/2">
          <d-input v-model="projectOneState" aria-label="project one state" required />
        </d-field>
      </div>
      <d-field label="Value of woodwork provided">
        <d-input v-model="projectOneValueOfWoodwork" aria-label="value of woodwork provided" min="0" type="number" required />
      </d-field>
      <d-field label="Year completed">
        <d-input v-model="projectOneYearCompleted" aria-label="year completed" :min="1950" :max="2500" type="number" required />
      </d-field>
      <d-field label="Project Summary">
        <d-input v-model="projectOneProjectSummary" aria-label="project summary" type="type" required />
      </d-field>


      <h3>Project #2</h3>
      <d-field label="Project Name">
        <d-input v-model="projectTwoName" aria-label="project two name" required />
      </d-field>
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="City" class="px-5 w-full md:w-1/2">
          <d-input v-model="projectTwoCity" aria-label="project two city" required />
        </d-field>
        <d-field label="State/Province" class="px-5 w-full md:w-1/2">
          <d-input v-model="projectTwoState" aria-label="project two state" required />
        </d-field>
      </div>
      <d-field label="Value of woodwork provided">
        <d-input v-model="projectTwoValueOfWoodwork" aria-label="project two value of woodwork" min="0" type="number" required />
      </d-field>
      <d-field label="Year completed">
        <d-input v-model="projectTwoYearCompleted" aria-label="project two year completed" :min="1950" :max="2500" type="number" required />
      </d-field>
      <d-field label="Project Summary">
        <d-input v-model="projectTwoProjectSummary" aria-label="project summary" type="type" required />
      </d-field>


      <h3>Project #3</h3>
      <d-field label="Project Name">
        <d-input v-model="projectThreeName" aria-label="project three name" required />
      </d-field>
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="City" class="px-5 w-full md:w-1/2">
          <d-input v-model="projectThreeCity" aria-label="project three city" required />
        </d-field>
        <d-field label="State/Province" class="px-5 w-full md:w-1/2">
          <d-input v-model="projectThreeState" aria-label="project three state/province" required />
        </d-field>
      </div>
      <d-field label="Value of woodwork provided">
        <d-input v-model="projectThreeValueOfWoodwork" aria-label="project three value of woodwork provided" min="0" type="number" required />
      </d-field>
      <d-field label="Year completed">
        <d-input v-model="projectThreeYearCompleted" aria-label="project three year completed" :min="1950" :max="2500" type="number" required />
      </d-field>
      <d-field label="Project Summary">
        <d-input v-model="projectThreeProjectSummary" aria-label="project summary" type="type" required />
      </d-field>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '../../../../Resources/scripts/utilities/field.utilities';
  import { APPLY_FOR_LICENSING_FORM } from '../../../../Resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('applyForLicensing');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['projectOneName', 'projectOneCity', 'projectOneState', 'projectOneValueOfWoodwork', 'projectOneYearCompleted', 'projectOneProjectSummary', 'projectTwoName', 'projectTwoCity', 'projectTwoState', 'projectTwoValueOfWoodwork', 'projectTwoYearCompleted', 'projectTwoProjectSummary', 'projectThreeName', 'projectThreeCity', 'projectThreeState', 'projectThreeValueOfWoodwork', 'projectThreeYearCompleted', 'projectThreeProjectSummary'],
        module: 'applyForLicensing',
        base: 'formFields',
        mutation: APPLY_FOR_LICENSING_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>